import { getGeoAssetPath } from '../../geo/config'
import { useGeoRuntime } from '../../geo/useGeoRuntime'
import { SupportedGeo } from '../../geo/config'

interface FormCurrencyProps {
  selectedGeo: SupportedGeo
}

import { getGeoCopyKey } from '../../geo/config'

export const FormCurrency = ({ selectedGeo }: FormCurrencyProps) => {
  const { geoConfigByGeo, language } = useGeoRuntime()

  const config = geoConfigByGeo(selectedGeo)

  const currencyFile = getGeoAssetPath(selectedGeo, config.layout.currency)

  return (
    <div className="inputCuttencyContainer input">
      <img src={currencyFile} alt="currency" className="currency" />

      <span
        className="currencyText"
        data-i18n={getGeoCopyKey(selectedGeo, language, 'hero.currency')}
      />
    </div>
  )
}
